import { createSlice } from "@reduxjs/toolkit";

const moviesSlice = createSlice({


    name: 'Movies',
    initialState: {
         nowPlayingMovies: null,
         trailerVideo: null,
         popularMovies: null,
         upcomingMovies: null,
         trendingMovies:null,
    },
    reducers: {
        addNowPlayingMovies: (state, action) => {
            state.nowPlayingMovies = action.payload
        },

        addTrailerVideo: (state, action)=>{

           state.trailerVideo = action.payload

        },
 
        addPopularMovies: (state, action) => {
              state.popularMovies = action.payload
        },
        addUpcomingMovies: (state, action) => {
              state.upcomingMovies = action.payload
        },
        addTrendingMovies: (state, action) => {
              state.trendingMovies = action.payload
        },

    }
})
export const {addNowPlayingMovies, addTrailerVideo, addPopularMovies,addUpcomingMovies,addTrendingMovies} = moviesSlice.actions
export default moviesSlice.reducer;